import axios from 'axios'
import { uuidv4 } from '/@/utils/uuid'
import { CURRENT_CONFIG } from './config'
import { message } from 'ant-design-vue'
import router from '/@/router'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types/enums'
export * from './type'

const REQUEST_ID = 'X-Request-Id'
const REFRESH_URL = '/manage/api/v1/token/refresh'
function getAuthToken () {
  return localStorage.getItem(ELocalStorageKey.Token)
}

let refreshTokenPromise: Promise<string | null> | null = null

function redirectToLogin () {
  const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
  localStorage.removeItem(ELocalStorageKey.Token)
  switch (flag) {
    case EUserType.Pilot:
      router.push(ERouterName.PILOT)
      break
    case EUserType.Web:
    default:
      router.push(ERouterName.PROJECT)
      break
  }
}

async function refreshAccessToken (): Promise<string | null> {
  if (!refreshTokenPromise) {
    const token = getAuthToken()
    if (!token) {
      return null
    }

    refreshTokenPromise = axios.post(
      REFRESH_URL,
      {},
      {
        baseURL: CURRENT_CONFIG.baseURL,
        headers: {
          'Content-Type': 'application/json',
          [ELocalStorageKey.Token]: token
        }
      }
    ).then(response => {
      const refreshedToken = response?.data?.data?.access_token
      if (refreshedToken) {
        localStorage.setItem(ELocalStorageKey.Token, refreshedToken)
        return refreshedToken
      }
      return null
    }).catch(() => null)
      .finally(() => {
        refreshTokenPromise = null
      })
  }

  return refreshTokenPromise
}

const instance = axios.create({
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 12000,
})

instance.interceptors.request.use(
  config => {
    const token = getAuthToken()
    if (token) {
      config.headers[ELocalStorageKey.Token] = token
    }
    // config.headers[REQUEST_ID] = uuidv4()
    config.baseURL = CURRENT_CONFIG.baseURL
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  response => {
    console.info('URL: ' + response.config.baseURL + response.config.url, '\nData: ', response.data, '\nResponse:', response)
    if (response.data.code && response.data.code !== 0) {
      message.error(response.data.message)
    }
    return response
  },
  async err => {
    const requestId = err?.config?.headers && err?.config?.headers[REQUEST_ID]
    if (requestId) {
      console.info(REQUEST_ID, '：', requestId)
    }
    console.info('url: ', err?.config?.url, `【${err?.config?.method}】 \n>>>> err: `, err)

    let description = '-'
    if (err.response?.data && err.response.data.message) {
      description = err.response.data.message
    }
    if (err.response?.data && err.response.data.result) {
      description = err.response.data.result.message
    }
    // @See: https://github.com/axios/axios/issues/383
    if (!err.response || !err.response.status) {
      message.error('The network is abnormal, please check the backend service and try again')
      return
    }
    if (err.response?.status !== 200) {
      message.error(`ERROR_CODE: ${err.response?.status}`)
    }
    if (err.response?.status === 401) {
      const originalRequest = err.config || {}
      const token = getAuthToken()
      if (token && !originalRequest._retry && originalRequest.url !== REFRESH_URL) {
        originalRequest._retry = true
        const refreshedToken = await refreshAccessToken()
        if (refreshedToken) {
          originalRequest.headers = originalRequest.headers || {}
          originalRequest.headers[ELocalStorageKey.Token] = refreshedToken
          return instance(originalRequest)
        }
      }
      console.error(err.response)
      redirectToLogin()
    }

    return Promise.reject(err)
  },
)

export default instance
